import styled from 'styled-components';

export const CalendarToolsTabContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;
